import { logger } from "@/lib/logger";

const isUnknownObject = (
  x: unknown,
): x is { [key in PropertyKey]: unknown } => {
  return x !== null && typeof x === "object";
};

export class AuthError extends Error {
  public code: string;

  constructor(authErr: unknown) {
    if (authErr === null || authErr === undefined) {
      super("Unknown Error");
      this.code = "UnknownException";
    } else if (typeof authErr === "string") {
      super(authErr);
      this.code = "BasicException";
    } else if (authErr instanceof Error) {
      super(authErr.message);
      this.code = authErr.name;
    } else if (
      isUnknownObject(authErr) &&
      "code" in authErr &&
      "message" in authErr
    ) {
      super(authErr.message as string); // TODO: narrow this down further
      this.code = authErr.code as string; // TODO: narrow this down further
    } else {
      super("Unknown Error");
      logger.error("Unknown auth error", authErr);
      this.code = "UnknownException";
    }

    this.name = "AuthError";
  }
}
